import GridContainer from '@jumbo/components/GridContainer';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import IdeasWidget from 'routes/Metrics/Classic/IdeasWidget';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AddIcon from '@mui/icons-material/Add';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';

const ManageAccounts = <ManageAccountsIcon style={{ color: '#ffffff' }} />;
const AssignmentInd = <AssignmentIndIcon style={{ color: '#ffffff' }} />;
const AddUserIcon = <AddIcon style={{ color: '#ffffff' }} />;
const KeyboardCmd = <KeyboardCommandKeyIcon style={{ color: '#ffffff' }} />;

let dashBoardPageData = [
  {
    id: 1,
    cardTitle: 'Assign Roles',
    cardValue: null,
    cardHref: '/assignRole',
    icon: ManageAccounts,
    backgroundColor: '#0795F4',
  },
  {
    id: 2,
    cardTitle: 'Manage Roles',
    cardValue: null,
    cardHref: '/manageRole',
    icon: AssignmentInd,
    backgroundColor: '#0795F4',
  },
  {
    id: 3,
    cardTitle: 'Add User',
    cardValue: null,
    cardHref: '/addUser',
    icon: AddUserIcon,
    backgroundColor: '#0795F4',
  },
  {
    id: 4,
    cardTitle: 'User Version Tracking',
    cardValue: null,
    cardHref: '/viewAppVersion',
    icon: KeyboardCmd,
    backgroundColor: '#0795F4',
  },
];

function index() {
  return (
    <div className="app-wrapper siteWrapper">
      <h4>Profile Management</h4>

      <PageContainer>
        <GridContainer>
          <Grid item xs={12} md={12} xl={12}>
            <GridContainer>
              {dashBoardPageData.map((item, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <IdeasWidget
                    number={item.cardValue ? item.CardValue : null}
                    subTitle={item.cardTitle}
                    backgroundColor={item.backgroundColor}
                    icon={item.icon}
                    linkOnArrow={item.cardHref}
                  />
                </Grid>
              ))}
            </GridContainer>
          </Grid>
        </GridContainer>
      </PageContainer>
    </div>
  );
}

export default index;
